import { IonButton, IonContent } from "@ionic/react";
import { AppHeader } from "../../components/Header/AppHeader";

const Entries: React.FC = () => {
	return (
		<>
			<AppHeader title="Entries" />
			<IonContent fullscreen className="ion-padding">
				<div className="container">
					<strong>Entries</strong>
					<p>Page content</p>
				</div>
			</IonContent>
		</>
	);
};

export default Entries;
